import store from "../../store/store";

export const componentKey = "INVENTORY_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setInventoryData: (state, action) => {
      state.inventoryData = action.payload;
    },
    getInventoriesListData: (state, action) => {
      state.inventoriesList = action.payload;
    },
    setCloseRequestInventoryDialog: (state, action) => {
      state.closeRequestInventoryDialog = action.payload;
    },
    setCloseAddNotesDialog: (state, action) => {
      state.closeAddNotesDialog = action.payload;
    },
    setGroupedNotesData: (state, action) => {
      state.groupedNotesData = action.payload;
    },
    setCloseSendBulkDialog: (state, action) => {
      state.closeSendBulkDialog = action.payload;
    },
    setCloseDeleteInventoryDialog: (state, action) => {
      state.closeDeleteInventoryDialog = action.payload;
    },
  },
  initialReducerState: {
    inventoryData: {},
    inventoriesList: {},
    closeRequestInventoryDialog: false,
    closeAddNotesDialog: false,
    groupedNotesData: [],
    closeSendBulkDialog: false,
    closeDeleteInventoryDialog: false,
  },
});

export const {
  setInventoryData,
  getInventoriesListData,
  setCloseRequestInventoryDialog,
  setCloseAddNotesDialog,
  setGroupedNotesData,
  setCloseSendBulkDialog,
  setCloseDeleteInventoryDialog,
} = actions;
